export default __webpack_public_path__ + "static/media/FraseEN.d48b7081.png";